// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3PfSs","newExpiryDate":"styles_newExpiryDate__1Hl3-","footer":"styles_footer__1jKb7"};